import { render, staticRenderFns } from "./reportHeadline.vue?vue&type=template&id=5bdc2b29&scoped=true"
import script from "./reportHeadline.vue?vue&type=script&lang=js"
export * from "./reportHeadline.vue?vue&type=script&lang=js"
import style0 from "./reportHeadline.vue?vue&type=style&index=0&id=5bdc2b29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdc2b29",
  null
  
)

export default component.exports